import React, {useRef, useState, useEffect} from 'react'
import {connect} from 'react-redux'
import {useLocation} from 'react-router-dom'
import MarkerTooltipsCollection from './MarkerTooltips/MarkerTooltipsCollection'
import {
  addCoordAction, addMarkAction,
  removeAllErrors,
  removeCoordinatesAction,
} from '../../../redux/actions/coordinates'
import {showMarkAction, openSidebarAction} from '../../../redux/actions/marks'
import {instrumentsAction} from '../../../redux/actions/instruments'
import {getCommentsAction} from '../../../redux/actions/likeAndComments'
import ModalWindowWrapper from '../../CommonComponents/ModalWindowWrapper'
import AddMapContent from '../../CommonComponents/ModalWindowWrapper/content/AddMapContent'
import {
  interpolateCoords,
  interpolateSquareCoords,
  interpolateCircleCoords,
  drawInterpolatedCoords,
} from '../../../helpers/Canvas/Interpolate'
import {eraserIcon} from './eraserIcon'
import {pointIcon} from './pointIcon'
import {pointMarkerPolygon} from '../../../helpers/Canvas/polygon'
import inside from '../../../helpers/Canvas/inside'
import {
  isInvalidIOSSize,
  calculateIOSCanvasSize,
  replaceCoordinates,
} from '../../../helpers/Canvas/size'
import yellow_x from '../../../static/images/location.png'
import css from './canvas.module.scss'
import { isMobile } from '../../../helpers/mobile'
import {altMapImage} from '../../../helpers/seo'
import {notify} from "react-notify-toast";

const lineInstruments = ['line', 'square', 'circle']
const isLineInstrument = (type) => lineInstruments.indexOf(type) >= 0

const DEFAULT_INSTRUMENT = 'grabbing'

const Canvas = (props) => {
  const toolTipsRef = useRef()
  const canvasRef = useRef()
  const canvasRef2 = useRef()
  const imgRef = useRef()
  const existingCoordsRef = useRef()

  const location = useLocation()
  const [altImageText, setAltImageText] = useState(altMapImage(location))

  const [canvas, setCanvas] = useState(null)
  const [ctx, setCtx] = useState(null)

  //aditional layer
  const [canvas2, setCanvas2] = useState(null)
  const [ctx2, setCtx2] = useState(null)

  const [clickedCoords, setClickedCoords] = useState(null)
  const canvasWidth = canvasRef.current?.width;
  // const pointRadius = window.innerWidth > 468 ? 10 : 30;
  const [pointRadius, setPointRadius] = useState(window.innerWidth > 468 ? 10 : 30);
  const [WH, setWH] = useState();
  const [isOpenEdit, setIsopenEdit] = useState(false)
  const [hoveredTitle, setHoveredTitle] = useState(null)

  // lines
  const [isDrawing, setIsDrawing] = useState(false)
  const [x1, setStartX] = useState(null)
  const [y1, setStartY] = useState(null)
  const [x2, setMouseX] = useState(null)
  const [y2, setMouseY] = useState(null)
  const lineWidth = 4

  // brush
  const [painting, setPainting] = useState(false)
  const [brushPointsArray, setBrushPointsArray] = useState([])
  // eraser
  const [erasing, setErasing] = useState(false)
  const [eraserPointsArray, setEraserPointsArray] = useState([])
  //coordinates for preview or all marks
  const [coordinates, setCoordinates] = useState([])

  // styles for canvas container (need for check canvas size memory limit)
  const [canvasSizeStyles, setCanvasSizeStyles] = useState({})

  // Mouse
  const [mouseCoordinates, setMouseCoordinates] = useState({x: 0, y: 0})

  // for mobile devices
  const [event, setEvent] = useState()
  const [isConfirmPopup, setIsConfirmPopup] = useState()
  const [isHelpPopup, setIsHelpPopup] = useState()
  const [confirmIconCoords, setConfirmIconCoords] = useState()
  const [confirmIcon, setConfirmIcon] = useState()

  const [selectedPoint, setSelectedPoint] = useState(null);
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [isMobileDevice] = useState(isMobile())

  const checkIsMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const devices = /iphone|ipod|ipad|android|blackberry|mini|windows\sce|palm/i;

    if (userAgent.match(devices)) {
      return true;
    }

    return false;
  }

  const checkOrientation = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    return width > height ? 'landscape' : 'portrait';
  }


  useEffect(() => {
    if (props.map && isInvalidIOSSize(props.map.width, props.map.height)) {
      const size = calculateIOSCanvasSize(props.map.width, props.map.height)
      setCanvasSizeStyles({
        width: `${size.width}px`,
        height: `${size.height}px`,
      })
    }

    setAltImageText(altMapImage(location))
  }, [props.map])

  useEffect(() => {
    if (props.coords && props.coords.isPreview) {
      setCoordinates([])
      props.coords.previewCoords.forEach((obj) => props.addCoordAction(obj))
    } else {
      setCoordinates(props.coords.existingCoords)
    }
  }, [props.coords?.previewCoords])

  // initial canvas settings
  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    let w, h
    if (isInvalidIOSSize(props.map.width, props.map.height)) {
      const size = calculateIOSCanvasSize(props.map.width, props.map.height)
      w = size.width
      h = size.height
    } else {
      w = props.map.width
      h = props.map.height
    }
    setPointRadius(window.innerWidth > 468 ? w > 4000 ? 10 : 5 : w > 4000 ? 20 : 5)
    setWH({w, h});
    showCoords(w, h)

    setCanvas(canvas)
    setCtx(ctx)

    canvas.width = w
    canvas.height = h

    const canvas2 = canvasRef2.current
    const ctx2 = canvas2.getContext('2d')
    setCanvas2(canvas2)
    setCtx2(ctx2)
    canvas2.width = w
    canvas2.height = h
  }, [coordinates])

  // render new coordinates
  useEffect(() => {
    if (props.newCoords && ctx) {
      drawCoordinates(props.newCoords)
    }
  }, [props.newCoords, coordinates])

  const drawPoint = (ctx, radius, x, y, color, border) => {
    x = Number(x)
    y = Number(y)

    const pointDrawRadius = radius * 3
    const xRight = x + pointDrawRadius
    const xLeft = x - pointDrawRadius
    const pointW = pointDrawRadius * 2
    const bezierPercent = pointDrawRadius * (1 - 65 / 100) // Sub 65% from point radius (optimal point)
    ctx.moveTo(x, y)
    ctx.lineTo(xLeft, y - pointW)
    ctx.bezierCurveTo(
      xLeft - bezierPercent,
      y - pointW * 2,
      xRight + bezierPercent,
      y - pointW * 2,
      xRight,
      y - pointW,
    )
    ctx.lineTo(x, y)
    if (border) {
      const ovalRadiusX = pointDrawRadius + 10;
      const ovalRadiusY = (pointW * 2) - 100;
      ctx.ellipse(x, y - pointW, ovalRadiusX, ovalRadiusY, 0, 0, 2 * Math.PI);

      ctx.strokeStyle = "red";
      ctx.lineWidth = 10;
      ctx.stroke();
    }
    ctx.fillStyle = color
    ctx.fill()
    ctx.beginPath()
  }

  //handlers for mobile devices
  const onTouchEnd = () => {
    if (props.instrument === 'brush') {
      props.addCoordAction({
        type: 'brush',
        coords: brushPointsArray,
        color: props.color,
        temp_id: Date.now(),
      })
      setBrushPointsArray([])
      setPainting(false)
    }
    if (props.instrument === 'eraser') {
      ctx.globalCompositeOperation = 'source-over'
      props.removeCoordinatesAction(eraserPointsArray)
      setEraserPointsArray([])
      setErasing(false)
    }
  }

  const onTouchStart = (e) => {
    //showMarkDataHandler(e, coordinates)
    e.preventDefault()
    if(isMobileDevice){
        console.log(555, e)
        setClickEventData(e)
        mouseMove(e)
    }

    // if (props.instrument === 'point' || props.instrument === 'grabbing') {
    //   if (props.instrument === 'point') {
    //     setEvent(Object.assign({}, e))
    //     const coord = getPosition(e, true)
    //     setConfirmIconCoords(coord)
    //     setConfirmIcon(true)
    //     setTimeout(() => setIsConfirmPopup(true), 2000)
    //   } else {
    //     setPoint(e)
    //   }
    // }

    // if (props.instrument === 'brush') {
    //   setPainting(true)
    // }

    // if (props.instrument === 'eraser') {
    //   setErasing(true)
    //   ctx.globalCompositeOperation = 'destination-out'
    // }

    // if (props.instrument === 'comment' && !props.coords.isPreview) {
    //   props.newCoords.forEach((element) => {
    //     if (element.type === 'point') {
    //       const coordsData = dataCoords(e)
    //       const x = coordsData.x
    //       const y = coordsData.y

    //       let cx = element.x
    //       let cy = element.y
    //       if (
    //         inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
    //         element.type === 'point' &&
    //         !element.data
    //       ) {
    //         setIsopenEdit(true)
    //         setClickedCoords(element)
    //       }
    //     }
    //   })
    // }
  }

  const onTouchStart2 = (e) => {
    showMarkDataHandler(e, coordinates)
    e.preventDefault()
    if(isMobileDevice){
        console.log(444, e)
        setClickEventData(e)
        mouseMove(e)
    }
    if (props.instrument === 'point' || props.instrument === 'grabbing') {
      if (props.instrument === 'point') {
        setEvent(Object.assign({}, e))
        const coord = getPosition(e, true)
        setConfirmIconCoords(coord)
        setConfirmIcon(true)
        setTimeout(() => setIsConfirmPopup(true), 2000)
      } else {
        setPoint(e)
      }
    }

    if (props.instrument === 'brush') {
      setPainting(true)
    }

    if (props.instrument === 'eraser') {
      setErasing(true)
      ctx.globalCompositeOperation = 'destination-out'
    }

    if (props.instrument === 'comment' && !props.coords.isPreview) {
      props.newCoords.forEach((element) => {
        if (element.type === 'point') {
          const coordsData = dataCoords(e)
          const x = coordsData.x
          const y = coordsData.y

          let cx = element.x
          let cy = element.y
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            element.type === 'point' &&
            !element.data
          ) {
            setIsopenEdit(true)
            setClickedCoords(element)
          }
        }
      })
    }
  }

  const onTouchStartLines = (e) => {
    const coordsData = dataCoords(e)
    const x = coordsData.x
    const y = coordsData.y

    if (isLineInstrument(props.instrument)) {
      if ((e.targetTouches && e.targetTouches[0]) || e.button === 0) {
        if (!isDrawing) {
          setStartX(x)
          setStartY(y)
          setIsDrawing(true)
        }
      }
    }
    showMarkDataHandler(e, coordinates)
  }

  const onTouchEndLine = (e) => {
    const {instrument} = props
    if (isLineInstrument(instrument)) {
      if (
        isDrawing &&
        x1 !== null &&
        x2 !== null &&
        y1 !== null &&
        y2 !== null
      ) {
        const coord = {
          coords: null,
          type: instrument,
          color: props.color,
          temp_id: Date.now(),
        }
        switch (instrument) {
          case 'line':
            coord.coords = interpolateCoords([
              [x1, y1],
              [x2, y2],
            ])
            break
          case 'square':
            coord.coords = interpolateSquareCoords([
              [x1, y1],
              [x2, y2],
            ])
            break
          case 'circle':
            coord.coords = interpolateCircleCoords([
              [x1, y1],
              [x2, y2],
            ])
            break
        }

        setStartX(null)
        setMouseX(null)
        setMouseY(null)
        setStartY(null)

        props.addCoordAction(coord)
        setIsDrawing(false)
      }
      switch (instrument) {
        case 'line':
          drawLine()
          break
        case 'square':
          drawSquare()
          break
        case 'circle':
          drawCircle()
          break
      }
      ctx2.clearRect(0, 0, canvas.width, canvas.height)
    }
  }

  const onTouchMoveLines = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y

    const {instrument} = props
    if (isLineInstrument(instrument)) {
      setMouseX(x)
      setMouseY(y)
      if (isDrawing) {
        switch (instrument) {
          case 'line':
            drawLine()
            break
          case 'square':
            drawSquare()
            break
          case 'circle':
            drawCircle()
            break
        }
      }
    }
  }

  const onTouchMove = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y
    if (props.instrument === 'brush') {
      if (painting) {
        const copy = JSON.parse(JSON.stringify(brushPointsArray))
        copy.push([x, y])
        setBrushPointsArray([...brushPointsArray, [x, y]])
      }
      drawWithBrush(e)
    }
    if (props.instrument === 'eraser') {
      if (eraserPointsArray.length > 1000) return
      if (erasing) {
        setEraserPointsArray([...eraserPointsArray, [x, y]])
      }
      drawWithEraser(e)
    }
  }

  function dataCoords(e) {
    const scaleData = canvas.getBoundingClientRect().width / canvas.width
    let clientX, clientY

    if (e.targetTouches) {
      clientX = e.targetTouches[0].clientX - e.targetTouches[0].radiusX / 2
      clientY = e.targetTouches[0].clientY - e.targetTouches[0].radiusY / 2
    }

    if (e.clientX) {
      clientX = e.clientX
      clientY = e.clientY
    }

    const x = (clientX - canvas.getBoundingClientRect().left) / scaleData
    const y = (clientY - canvas.getBoundingClientRect().top) / scaleData
    return {x: (x-2).toFixed(), y: y.toFixed()}
  }

  // draw elements on the map
  const setPoint = (e) => {
    if (props.instrument === 'point') {
      getPosition(e)
    } else if (props.instrument === DEFAULT_INSTRUMENT) {
      showNewMarkDataHandler(e, props.newCoords)
    }

    if (props.instrument === 'comment' && !props.coords.isPreview) {
      props.newCoords.forEach((element) => {
        if (element.type === 'point') {
          const coordsData = dataCoords(e)
          const x = coordsData.x
          const y = coordsData.y

          let cx = element.x
          let cy = element.y
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            element.type === 'point' &&
            !element.data
          ) {
            setIsopenEdit(true)
            setClickedCoords(element)
          }
        }
      })
    }

    showMarkDataHandler(e, coordinates)
  }

  const showMarkDataHandler = (e, coords) => {
    const coordsData = dataCoords(e)
    const x = coordsData.x
    const y = coordsData.y
    let marksToShow = []
    let isShow = false
    coords.map((item) => {
      item.items.map((item) => {
        const mapItem = item.meta
        if (mapItem.type === 'point') {
          const invalidIOSSize = isInvalidIOSSize(
            props.map.width,
            props.map.height,
          )
          const mapSize = {
            width: Number(props.map.width),
            height: Number(props.map.height),
          }
          const calculatedSize = invalidIOSSize
            ? calculateIOSCanvasSize(props.map.width, props.map.height)
            : null
          const coords = calculatedSize
            ? replaceCoordinates(
              calculatedSize.width,
              calculatedSize.height,
              mapSize.width,
              mapSize.height,
              [mapItem.x, mapItem.y],
            )
            : [mapItem.x, mapItem.y]
          let cx = coords[0]
          let cy = coords[1]
          let isMobile = checkIsMobile();
          let orientation = checkOrientation();
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius, isMobile, orientation)) &&
            item.title
          ) {
            if (selectedPoint) {
              const {xPoint, yPoint} = selectedPoint;
              ctx.clearRect(xPoint - pointRadius * 50, yPoint - pointRadius * 50, pointRadius * 100, pointRadius * 100);
            }
            const xPointNew = item.meta.x
            const yPointNew = item.meta.y
            setSelectedPoint({xPoint: xPointNew, yPoint: yPointNew});
            if (!isShow) {
              const canvas = existingCoordsRef.current
              const ctx = canvas.getContext('2d')
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              setTimeout(() => {
                showCoords(WH.w, WH.h, {xPoint: xPointNew, yPoint: yPointNew});
              }, 10)
              isShow = true
            }
            marksToShow.push(item)
          }
        }
      })
    })

    if (marksToShow.length > 0) {
      const ids = marksToShow.map((el) => el.id)
      const max = Math.max(...ids)
      const actualMark = marksToShow[ids.indexOf(max)]

      props.showMarkAction(actualMark.id)
      props.getCommentsAction(actualMark.id)
      props.openSidebarAction()
    }

    props.newCoords &&
    props.newCoords.forEach((item) => {
      if (item.type === 'point') {
        let cx = item.x
        let cy = item.y
        if (
          inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
          item.title &&
          item.id
        ) {
          props.showMarkAction(item.id)
          props.getCommentsAction(item.id)
          props.openSidebarAction()
        }
      }
    })
  }

  useEffect(() => {
    if (props.isOpenSidebar === false && props.isOpenSidebar !== isOpenSidebar && selectedPoint) {
      const pointRadius = 20;
      const {xPoint, yPoint} = selectedPoint;
      if (selectedPoint) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // ctx.clearRect(xPoint - pointRadius * 50, yPoint - pointRadius * 100, pointRadius * 100, pointRadius * 100);
        showCoords(WH.w, WH.h, null);

      }
    }
    setIsOpenSidebar(props.isOpenSidebar);
  }, [props.isOpenSidebar]);


  const showNewMarkDataHandler = (e, coords) => {
    const coordsData = dataCoords(e)
    const x = coordsData.x
    const y = coordsData.y

    coords.forEach((element) => {
      if (element.type === 'point') {
        const invalidIOSSize = isInvalidIOSSize(
          props.map.width,
          props.map.height,
        )
        const mapSize = {
          width: Number(props.map.width),
          height: Number(props.map.height),
        }
        const calculatedSize = invalidIOSSize
          ? calculateIOSCanvasSize(props.map.width, props.map.height)
          : null
        const coords = calculatedSize
          ? replaceCoordinates(
            calculatedSize.width,
            calculatedSize.height,
            mapSize.width,
            mapSize.height,
            [element.x, element.y],
          )
          : [element.x, element.y]
        let cx = coords[0]
        let cy = coords[1]

        if (
          inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
          element.temp_id
        ) {
          setIsopenEdit(true)
          setClickedCoords(element)
        }
      }
    })
  }

  //  brush drawing
  const drawWithBrush = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y
    if (!painting) return
    ctx.lineWidth = lineWidth
    // ctx.lineCap = 'round';
    ctx.strokeStyle = props.color
    ctx.lineTo(x, y)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(x, y)
  }

  //  eraser drawing
  const drawWithEraser = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y
    const xStart = coords.x
    const yStart = coords.y
    if (!erasing) return
    ctx.lineWidth = 20
    // ctx.lineCap = 'round';
    ctx.strokeStyle = '#fff'
    ctx.lineTo(x, y)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(xStart, yStart)
  }

  // detect canvas coordinates
  function getPosition(e, confirm) {
    if (props.instrument === 'point') {
      const coords = dataCoords(e)
      const x = coords.x-1
      const y = coords.y

      const coord = {
        x,
        y,
        type: props.instrument,
        color: props.color,
        temp_id: Date.now(),
        radius: pointRadius,
        polygon: pointMarkerPolygon(x, y, pointRadius),
      }
      if (!confirm) {
        let promise = new Promise((res, rej) => {
          res(props.addCoordAction(coord))
        })
        promise.then(() => {
          setIsopenEdit(true)
          setClickedCoords(coord)
        })
      } else {
        return coord
      }
    }
  }

  function drawCoordinates(copy) {
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    copy.map((item) => {
      if (item.type === 'line' && item.coords) {
        ctx.lineWidth = lineWidth
        ctx.strokeStyle = item.color
        ctx.stroke()
        ctx.beginPath()

        for (let i = 0; i < item.coords.length; i++) {
          ctx.lineTo(item.coords[i][0], item.coords[i][1])
          ctx.moveTo(item.coords[i][0], item.coords[i][1])
        }
        ctx.stroke()
        ctx.beginPath()
      }
      if (item.type === 'square' && item.coords) {
        const {color, coords} = item
        drawInterpolatedCoords(ctx, {color, coords}, lineWidth)
        // square(ctx, coords[0][0], coords[0][1], coords[1][0], coords[1][1], color)
      }
      if (item.type === 'circle' && item.coords) {
        const {color, coords} = item
        drawInterpolatedCoords(ctx, {color, coords}, lineWidth)
        // ellipse(ctx, coords[0][0], coords[0][1], coords[1][0], coords[1][1], color)
      }
      if (item.type === 'point') {
        props.instrumentsAction(DEFAULT_INSTRUMENT)
        drawPoint(ctx, pointRadius, item.x, item.y, item.color)
      }
      if (item.type === 'brush') {
        ctx.lineWidth = lineWidth
        ctx.strokeStyle = item.color
        ctx.stroke()
        ctx.beginPath()

        for (let i = 0; i < item.coords.length; i++) {
          ctx.lineTo(item.coords[i][0], item.coords[i][1])
          ctx.moveTo(item.coords[i][0], item.coords[i][1])
        }
        ctx.stroke()
        ctx.beginPath()
      }
    })
  }

  const isInsideCircle = (pinX, pinY, circleCenterX, circleCenterY, circleRadius) => {
    const distance = Math.sqrt((pinX - circleCenterX) ** 2 + (pinY - circleCenterY) ** 2);
    return distance <= circleRadius;
  }

  const handleCloseEditModal = (close) => {
    setIsopenEdit(false);
    props.removeAllErrors()
    if (!close) {
      const map = props.map;
      const temp_id = props.temp_id;
      const submissionId = props.submissionId;
      const filteredData = props.newCoords
      const elementsArray = []
      const invalidIOSSize = isInvalidIOSSize(map.width, map.height)
      const mapSize = {width: Number(map.width), height: Number(map.height)}
      const calculatedSize = invalidIOSSize
        ? calculateIOSCanvasSize(map.width, map.height)
        : null
      const replaceCoords = (c) =>
        replaceCoordinates(
          mapSize.width,
          mapSize.height,
          calculatedSize.width,
          calculatedSize.height,
          c,
        )
      filteredData &&
      filteredData.map((element) => {
        let obj

        if (element.type === 'point') {
          obj = {meta: {}}
          const coords = invalidIOSSize
            ? replaceCoords([element.x, element.y])
            : [element.x, element.y]
          obj.meta.type = element.type
          obj.meta.radius = element.radius
          obj.meta.color = element.color
          obj.meta.x = coords[0]
          obj.meta.y = coords[1]
        }

        if (element.type === 'line') {
          obj = {meta: {}}
          obj.meta.type = element.type
          obj.meta.color = element.color
          obj.meta.array = invalidIOSSize
            ? replaceCoords(element.coords)
            : element.coords
        }

        if (element.type === 'square') {
          obj = {meta: {}}
          obj.meta.type = element.type
          obj.meta.color = element.color
          obj.meta.array = invalidIOSSize
            ? replaceCoords(element.coords)
            : element.coords
        }

        if (element.type === 'circle') {
          obj = {meta: {}}
          obj.meta.type = element.type
          obj.meta.color = element.color
          obj.meta.array = invalidIOSSize
            ? replaceCoords(element.coords)
            : element.coords
        }

        if (element.type === 'brush') {
          obj = {meta: {}}
          obj.meta.type = element.type
          obj.meta.color = element.color
          obj.meta.array = invalidIOSSize
            ? replaceCoords(element.coords)
            : element.coords
        }

        if (obj) {
          if (element.id) {
            obj.id = element.id
          }
          elementsArray.push(obj)
        }
        return element
      })
      const data = {
        temp_id: `${+temp_id}`,
        map_id: map.id,
        items: elementsArray,
      }
      if (submissionId) {
        data.submission_id = submissionId
      }

      instrumentsAction(DEFAULT_INSTRUMENT)
      if (data.items.length > 0) {
        if (filteredData.filter((el) => el.type === 'point').length === 0) {
          return alertHandler('point_required')
        }
        alertHandler('success')
        instrumentsAction('save');

        return props.addMarkAction(data, alertHandler)
      } else return alertHandler('empty')
    }
  }

  const alertHandler = (type) => {
    let errorColor = {background: '#f44336', text: '#FFFFFF'}
    let successColor = {background: '#1ec30e', text: '#FFFFFF'}
    let infoColor = {background: '#fff3cd', text: '#000'}
    if (type === 'success') {
      notify.show(
        'Submitted successfully, pending approval. Thank you for your contribution!',
        'custom',
        3000,
        successColor,
      )
    }
    if (type === 'empty') {
      notify.show('Nothing to save', 'custom', 3000, errorColor)
    }
    if (type === 'not_authourized') {
      notify.show('Please login to edit the map.', 'custom', 3000, errorColor)
    }
    if (type === 'error') {
      notify.show('Error occurred', 'custom', 3000, errorColor)
    }
    if (type === 'point_required') {
      notify.show(
        'Please place the Pin Drop Marker on the map to leave notes.',
        'custom',
        5000,
        infoColor,
      )
    }
  }

  // drawing lines
  function drawLine() {
    ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
    if (isDrawing && x1 !== null && x2 !== null && y1 !== null && y2 !== null) {
      ctx2.strokeStyle = 'darkred'
      ctx2.lineWidth = lineWidth
      ctx2.beginPath()
      ctx2.moveTo(x1, y1)
      ctx2.lineTo(x2, y2)
      ctx2.stroke()
      ctx2.beginPath()
    }
  }

  // draw square
  function drawSquare() {
    ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
    if (isDrawing && x1 !== null && x2 !== null && y1 !== null && y2 !== null) {
      square(ctx2, x1, y1, x2, y2, 'darkred')
    }
  }

  function square(context, sx1, sy1, sx2, sy2, color) {
    context.strokeStyle = color
    context.lineWidth = lineWidth
    context.beginPath()
    context.moveTo(sx1, sy1)
    context.rect(sx1, sy1, sx2 - sx1, sy2 - sy1)
    context.stroke()
    context.beginPath()
  }

  // draw circle
  function drawCircle() {
    ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
    if (isDrawing && x1 !== null && x2 !== null && y1 !== null && y2 !== null) {
      ellipse(ctx2, x1, y1, x2, y2, 'darkred')
    }
  }

  function ellipse(context, ex1, ey1, ex2, ey2, color) {
    ex1 = +ex1
    ey1 = +ey1
    ex2 = +ex2
    ey2 = +ey2
    const toLeft = ex1 > ex2
    const toTop = ey1 > ey2
    const ew = toLeft ? ex1 - ex2 : ex2 - ex1
    const eh = toTop ? ey1 - ey2 : ey2 - ey1
    const exr = ew / 2
    const eyr = eh / 2
    const ecx = toLeft ? ex1 - exr : ex1 + exr
    const ecy = toTop ? ey1 - eyr : ey1 + eyr
    context.strokeStyle = color
    context.lineWidth = lineWidth
    context.beginPath()
    context.ellipse(ecx, ecy, exr, eyr, 0, 0, 2 * Math.PI)
    context.stroke()
    context.beginPath()
  }

  function placeDiv(x_pos, y_pos) {
    const d = toolTipsRef.current
    const x = parseInt(x_pos) + 10
    const y = parseInt(y_pos) + 10
    if (d) {
      d.style.position = 'absolute'
      d.style.left = x + 'px'
      d.style.top = y + 'px'
      d.style.width = '120px'
      d.style.backgroundColor = '#555'
      d.style.color = '#fff'
      d.style.textAlign = 'center'
      d.style.borderRadius = '6px'
      d.style.zIndex = '2222222222222222222'
      d.style.height = 'min-content'
      d.style.padding = '5px 10px'
    }
  }

  const mouseDown = (e) => {
    if (props.instrument === 'brush') {
      setPainting(true)
    }
    if (props.instrument === 'eraser') {
      setErasing(true)
      ctx.globalCompositeOperation = 'destination-out'
    }
  }

  const mouseMove = (e) => {
    if (canvas) {
      const coords = dataCoords(e)
      const x = coords.x
      const y = coords.y

      if (hoveredTitle) {
        setHoveredTitle(null)
      }

      // new coords
      props.newCoords &&
      props.newCoords.forEach((element) => {
        if (element.type === 'point') {
          let cx = element.x
          let cy = element.y
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            element.type === 'point' &&
            element.title
          ) {
            let promise = new Promise((res, rej) => {
              res(setHoveredTitle(element.title))
            })
            promise.then((res) => {
              placeDiv(x, y, element.title)
            })
          }
        }
      })

      if (props.instrument === 'brush') {
        if (painting) {
          setBrushPointsArray([...brushPointsArray, [x, y]])
        }
        drawWithBrush(e)
      }
      if (props.instrument === 'eraser') {
        if (eraserPointsArray.length > 1000) return
        if (erasing) {
          setEraserPointsArray([...eraserPointsArray, [x, y]])
        }
        drawWithEraser(e)
      }
    }
    if (canvas) {
      showTitleForExistingCoords(e)
    }
  }

  const mouseUp = (e) => {
    if (props.instrument === 'brush') {
      props.addCoordAction({
        type: 'brush',
        coords: interpolateCoords(brushPointsArray),
        color: props.color,
        temp_id: Date.now(),
      })
      setBrushPointsArray([])
      setPainting(false)
    }
    if (props.instrument === 'eraser') {
      ctx.globalCompositeOperation = 'source-over'
      props.removeCoordinatesAction(eraserPointsArray)
      setEraserPointsArray([])
      setErasing(false)
    }
  }

  const mouseDown2 = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y

    const {instrument} = props
    if (isLineInstrument(instrument)) {
      if (
        (e.targetTouches &&
          e.targetTouches[0] &&
          e.targetTouches[0].identifier === 0) ||
        e.button === 0
      ) {
        if (!isDrawing) {
          setStartX(x)
          setStartY(y)
          setIsDrawing(true)
        }

        switch (instrument) {
          case 'line':
            drawLine(x, y)
            break
          case 'square':
            drawSquare()
            break
          case 'circle':
            drawCircle()
            break
        }
      }
    }
  }

  const mouseMove2 = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y
    if (canvas) {
      if (hoveredTitle) {
        setHoveredTitle(null)
      }

      props.newCoords.forEach((element) => {
        if (element.type === 'point') {
          let cx = element.x
          let cy = element.y
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            element.type === 'point' &&
            element.title
          ) {
            let promise = new Promise((res, rej) => {
              res(setHoveredTitle(element.title))
            })
            promise.then((res) => {
              placeDiv(x, y, element.title)
            })
          }
        }
      })
    }

    const {instrument} = props
    if (isLineInstrument(instrument)) {
      setMouseX(x)
      setMouseY(y)
      if (isDrawing) {
        switch (instrument) {
          case 'line':
            drawLine()
            break
          case 'square':
            drawSquare()
            break
          case 'circle':
            drawCircle()
            break
        }
      }
    }
    showTitleForExistingCoords(e, coordinates)
  }

  const showTitleForExistingCoords = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y
    setMouseCoordinates({x, y})

    coordinates.forEach((item) => {
      item.items.forEach((item) => {
        const mapItem = item.meta
        if (mapItem.type === 'point') {
          const invalidIOSSize = isInvalidIOSSize(
            props.map.width,
            props.map.height,
          )
          const mapSize = {
            width: Number(props.map.width),
            height: Number(props.map.height),
          }
          const calculatedSize = invalidIOSSize
            ? calculateIOSCanvasSize(props.map.width, props.map.height)
            : null
          const coords = calculatedSize
            ? replaceCoordinates(
              calculatedSize.width,
              calculatedSize.height,
              mapSize.width,
              mapSize.height,
              [mapItem.x, mapItem.y],
            )
            : [mapItem.x, mapItem.y]
          let cx = coords[0]
          let cy = coords[1]
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            item.title
          ) {
            let promise = new Promise((res, rej) => {
              res(setHoveredTitle(item.title))
            })
            promise.then((res) => {
              placeDiv(x, y, item.title)
            })
          }
        }
      })
    })
  }

  const mouseUp2 = (e) => {
    const {instrument} = props
    if (isLineInstrument(instrument)) {
      if (
        (e.targetTouches &&
          e.targetTouches[0] &&
          e.targetTouches[0].identifier &&
          e.targetTouches[0].identifier === 0) ||
        e.button === 0
      ) {
        if (isDrawing) {
          const coord = {
            coords: [],
            type: instrument,
            color: props.color,
            temp_id: Date.now(),
          }
          switch (instrument) {
            case 'line':
              coord.coords = interpolateCoords([
                [x1, y1],
                [x2, y2],
              ])
              break
            case 'square':
              coord.coords = interpolateSquareCoords([
                [x1, y1],
                [x2, y2],
              ])
              break
            case 'circle':
              coord.coords = interpolateCircleCoords([
                [x1, y1],
                [x2, y2],
              ])
              break
          }
          props.addCoordAction(coord)
          setIsDrawing(false)
        }
        switch (instrument) {
          case 'line':
            drawLine()
            break
          case 'square':
            drawSquare()
            break
          case 'circle':
            drawCircle()
            break
        }
      }
    }
  }

  const setPoint2 = (e) => {
    const coords = dataCoords(e)
    const x = coords.x
    const y = coords.y

    if (props.instrument === 'line') {
      drawLine('setPoint2', x1, y1, x, y)
    }
    if (props.instrument === 'square') {
      drawSquare()
    }
    if (props.instrument === 'circle') {
      drawCircle()
    }
    if (props.instrument === 'comment' && !props.coords.isPreview) {
      props.newCoords &&
      props.newCoords.forEach((element) => {
        if (element.type === 'point') {
          let cx = element.x
          let cy = element.y
          if (
            inside([x, y], pointMarkerPolygon(cx, cy, pointRadius)) &&
            element.type === 'point' &&
            !element.data
          ) {
            setIsopenEdit(true)
            setClickedCoords(element)
          }
        }
      })
    }
    // showMarkDataHandler(e, coordinates);
  }

  const showCoords = (w, h, selectedPoint) => {
    const canvas = existingCoordsRef.current
    const ctx = canvas.getContext('2d')
    setCanvas(canvas)
    setCtx(ctx)
    canvas.width = w
    canvas.height = h
    const mapSize = {w: props.map.width, h: props.map.height}
    const isResized =
      Number(w) !== Number(mapSize.w) || Number(h) !== Number(mapSize.h)
    const clonedCoordinates = JSON.parse(JSON.stringify(coordinates));
    clonedCoordinates.map((item) => {
      item.items.map((item, index) => {
        const mapItem = item.meta
        if (
          mapItem &&
          mapItem.type === 'point' &&
          mapItem.x &&
          mapItem.y &&
          mapItem.radius
        ) {
          const coords = isResized
            ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [
              mapItem.x,
              mapItem.y,
            ])
            : [mapItem.x, mapItem.y]
          drawPoint(ctx, pointRadius, coords[0], coords[1], mapItem.color)
        }
        if (mapItem.type === 'line') {
          mapItem.array = isResized
            ? replaceCoordinates(w, h, mapSize.w, mapSize.h, mapItem.array)
            : mapItem.array

          let isNearBrush = false;
          if (selectedPoint) {
            const { xPoint, yPoint } = selectedPoint;
            const coords1 = isResized
              ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [
                xPoint,
                yPoint,
              ])
              : [xPoint, yPoint]

            for (let i = 1; i < mapItem.array.length; i++) {
              const dist = distanceFromPointToLineSegment(
                coords1[1], coords1[1],
                mapItem.array[i - 1][0], mapItem.array[i - 1][1],
                mapItem.array[i][0], mapItem.array[i][1]
              );
              if (dist <= 100) {
                isNearBrush = true;
                break;
              }
            }
          }
          ctx.lineWidth = isNearBrush ? (isResized ? 6 : 8) : lineWidth;
          // ctx.lineWidth = lineWidth
          ctx.strokeStyle = mapItem.color
          ctx.stroke()
          ctx.beginPath()
          if (mapItem.array) {
            for (let i = 0; i < mapItem.array.length; i++) {
              ctx.lineTo(mapItem.array[i][0], mapItem.array[i][1])
              ctx.moveTo(mapItem.array[i][0], mapItem.array[i][1])
            }
          }
          ctx.stroke()
          ctx.beginPath()
        }
        if (mapItem.type === 'square' && mapItem.array) {
          mapItem.array = isResized
            ? replaceCoordinates(w, h, mapSize.w, mapSize.h, mapItem.array)
            : mapItem.array
          const {color, array: coords} = mapItem
          let newLineWidth;
          if (selectedPoint) {
            const {xPoint, yPoint} = selectedPoint;
            const coords1 = isResized
              ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [
                xPoint,
                yPoint,
              ])
              : [xPoint, yPoint]
            const xValues = coords.map(coord => coord[0]);
            const yValues = coords.map(coord => coord[1]);

            const x1 = Math.min(...xValues);
            const y1 = Math.min(...yValues);
            const x2 = Math.max(...xValues);
            const y2 = Math.max(...yValues);
            if (selectedPoint && isInsideSquare(coords1[0], coords1[1], x1, y1, x2, y2)) {
              newLineWidth = (isResized ? 6 : 12);
            } else {
              newLineWidth = lineWidth
            }
          } else {
            newLineWidth = lineWidth
          }
          drawInterpolatedCoords(ctx, {color, coords}, newLineWidth)
          // square(ctx, coords[0][0], coords[0][1], coords[1][0], coords[1][1], color)
        }
        if (mapItem.type === 'circle' && mapItem.array) {
          mapItem.array = isResized
            ? replaceCoordinates(w, h, mapSize.w, mapSize.h, mapItem.array)
            : mapItem.array;
          const { color, array: coords } = mapItem;

          let newLineWidth;
          if (selectedPoint) {
            const { xPoint, yPoint } = selectedPoint;
            const coords1 = isResized
              ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [xPoint, yPoint])
              : [xPoint, yPoint];
            const radius = findCircleCenterAndRadius(coords);

            const distance = Math.sqrt((coords1[0] - radius.centerX) ** 2 + (coords1[1] - radius.centerY) ** 2);
            const threshold = parseInt(radius.radius, 10) + 10;

            if (selectedPoint && distance <= threshold) {
              newLineWidth = (isResized ? 6 : 12);
            } else {
              newLineWidth = lineWidth;
            }
          } else {
            newLineWidth = lineWidth;
          }
          drawInterpolatedCoords(ctx, { color, coords }, newLineWidth);
          // ellipse(ctx, coords[0][0], coords[0][1], coords[1][0], coords[1][1], color)
        }

        if (mapItem.type === 'brush') {
          mapItem.array = isResized
            ? replaceCoordinates(w, h, mapSize.w, mapSize.h, mapItem.array)
            : mapItem.array
          let isNearBrush = false;
          if (selectedPoint) {
            const {xPoint, yPoint} = selectedPoint;
            const coords1 = isResized
              ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [
                xPoint,
                yPoint,
              ])
              : [xPoint, yPoint]

            for (let i = 1; i < mapItem.array.length; i++) {
              const dist = distanceFromPointToLineSegment(
                coords1[0], coords1[1],
                mapItem.array[i - 1][0], mapItem.array[i - 1][1],
                mapItem.array[i][0], mapItem.array[i][1]
              );
              if (dist <= 150) {
                isNearBrush = true;
                break;
              }
            }
          }
          ctx.lineWidth = isNearBrush ? (isResized ? 6 : 8) : lineWidth;
          ctx.strokeStyle = mapItem.color
          ctx.stroke()
          ctx.beginPath()
          for (let i = 0; i < mapItem.array.length; i++) {
            ctx.lineTo(mapItem.array[i][0], mapItem.array[i][1])
            ctx.moveTo(mapItem.array[i][0], mapItem.array[i][1])
          }
          ctx.stroke()
          ctx.beginPath()
        }
      })
    })
    if (selectedPoint) {
      const coords = isResized
        ? replaceCoordinates(w, h, mapSize.w, mapSize.h, [
          selectedPoint.xPoint,
          selectedPoint.yPoint,
        ])
        : [selectedPoint.xPoint, selectedPoint.yPoint]
      drawPoint(ctx, isResized ? 10 : 15, coords[0], coords[1], 'green');
    }
  }

  const distanceFromPointToLineSegment = (x, y, x1, y1, x2, y2) => {
    const A = x - x1;
    const B = y - y1;
    const C = x2 - x1;
    const D = y2 - y1;

    const dot = A * C + B * D;
    const len_sq = C * C + D * D;
    let param = -1;
    if (len_sq !== 0) param = dot / len_sq;

    let xx, yy;

    if (param < 0) {
      xx = x1;
      yy = y1;
    } else if (param > 1) {
      xx = x2;
      yy = y2;
    } else {
      xx = x1 + param * C;
      yy = y1 + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  }

  const isInsideSquare = (x, y, x1, y1, x2, y2) => {
    return x >= x1 && x <= x2 && y >= y1 && y <= y2;
  }

  const average = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;

  const findCircleCenterAndRadius = (coords) => {
    const centerX = average(coords.map(coord => coord[0]));
    const centerY = average(coords.map(coord => coord[1]));

    const radii = coords.map(coord => Math.sqrt((coord[0] - centerX) ** 2 + (coord[1] - centerY) ** 2));
    const averageRadius = average(radii);

    return {
      centerX,
      centerY,
      radius: averageRadius
    };
  };


  const setCursor = () => {
    if (props.instrument === 'square') return 'crosshair'
    if (props.instrument === 'circle') return 'crosshair'
    if (props.instrument === 'brush') return 'crosshair'
    if (props.instrument === 'line') return 'crosshair'
    if (props.instrument === 'eraser') return eraserIcon
    if (props.instrument === 'point') return pointIcon
    if (props.instrument === 'comment') return 'pointer'
    if (props.zoomed) return 'grabbing'
  }

  const handleDeletePoint = {}
  const renderEditModal = isOpenEdit ? (
    <ModalWindowWrapper
      title={'Annotate Map'}
      content={
        <>
          <AddMapContent
            clickedCoords={clickedCoords}
            onClose={handleCloseEditModal}
            handleDeletePoint={handleDeletePoint}
          />
        </>
      }
      onClose={handleCloseEditModal}
    />
  ) : null

  const handleCloseConfirmPopup = () => {
    setIsHelpPopup(false)
    setIsConfirmPopup(false)
    setConfirmIcon(false)
    props.instrumentsAction(DEFAULT_INSTRUMENT)
  }

  const handleIsHelpPopup = () => setIsHelpPopup(true)

  const handleConfirm = () => {
    setPoint(event)
    setIsConfirmPopup(false)
    setIsHelpPopup(false)
    setConfirmIcon(false)
  }

  const renderConfirmPopup = isConfirmPopup ? (
    <ModalWindowWrapper
      miniTitle={true}
      title={
        isHelpPopup
          ? 'Quick tip:'
          : 'You have dropped the pin marker, is it placed correctly in the area you drew?'
      }
      content={
        isHelpPopup ? (
          <>
            <p className={css.tip}>
              To make it easier to drop the pin in the right place, please
              locate and zoom in on your drawn area before dropping the pin
              marker again. Then click the pin marker icon in the toolbar to
              drop the marker again.
            </p>
            <button
              className={css.confirmBtn}
              onClick={handleCloseConfirmPopup}
            >
              I understand
            </button>
          </>
        ) : (
          <>
            <div className={css.btnWrapper}>
              <button className={css.confirmBtn} onClick={handleConfirm}>
                Yes, pin marker is in the correct area, continue...
              </button>
              <button className={css.closeBtn} onClick={handleIsHelpPopup}>
                No, I need to move the pin.
              </button>
            </div>
          </>
        )
      }
      onClose={handleCloseConfirmPopup}
    />
  ) : null

  const [clickEventData, setClickEventData] = React.useState(null);
  const handleClickMarkerTooltip = () => {
    setPoint(clickEventData)
    onTouchStart2(clickEventData)
  }

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: props.map.width,
          height: props.map.height,
          ...canvasSizeStyles,
        }}
      >
        {renderEditModal}
        {renderConfirmPopup}
        {confirmIcon && (
          <img
            alt="yellow X"
            src={yellow_x}
            style={{
              position: 'relative',
              top: `${confirmIconCoords?.y}px`,
              left: `${confirmIconCoords?.x}px`,
              transform: 'translate(-50%, -50%)',
              width: '50px',
              height: '50px',
              zIndex: 2,
            }}
          />
        )}
        <canvas
          ref={canvasRef}
          onMouseDown={mouseDown}
          onMouseUp={mouseUp}
          onMouseMove={mouseMove}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onClick={setPoint}
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            visibility: 'visible',
            zIndex: `${!isLineInstrument(props.instrument) ? '2' : '1'}`,
            maxWidth: '100%',
            width: '100%',
            cursor: setCursor(),
          }}
        ></canvas>
        <canvas
          ref={canvasRef2}
          onMouseDown={mouseDown2}
          onMouseUp={mouseUp2}
          onMouseMove={mouseMove2}
          onClick={setPoint2}
          onTouchStart={onTouchStartLines}
          onTouchMove={onTouchMoveLines}
          onTouchEnd={onTouchEndLine}
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            visibility: 'visible',
            zIndex: `${isLineInstrument(props.instrument) ? '2' : '1'}`,
            maxWidth: '100%',
            width: '100%',
            cursor: setCursor(),
          }}
        ></canvas>

        <canvas
          ref={existingCoordsRef}
          onMouseDown={mouseDown}
          onMouseUp={mouseUp}
          onMouseMove={mouseMove}
          onClick={setPoint}
          onTouchStart={onTouchStart}
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            visibility: 'visible',
            maxWidth: '100%',
            width: '100%',
            cursor: setCursor(),
          }}
        ></canvas>
        <img
          ref={imgRef}
          src={props.img}
          alt={altImageText}
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            visibility: 'visible',
            zIndex: '-1',
            maxWidth: '100%',
            width: '100%',
          }}
        />
      </div>
      <MarkerTooltipsCollection
        map={props.map}
        mouseX={mouseCoordinates.x}
        mouseY={mouseCoordinates.y}
        pointRadius={pointRadius}
        coordinates={coordinates}
        newCoordinates={props.newCoords}
        onClick={handleClickMarkerTooltip}
      />
    </>
  )
}

// {hoveredTitle && <div ref={toolTipsRef}>{hoveredTitle}</div>}

const mapStateToProps = (state) => {
  return {
    isOpenDrawInstruments: state.modals.isDrawInstrumentsOpen,
    instrument: state.instruments.instrument,
    zoomed: state.instruments.zoomed,
    newCoords: state.newCoords.newCoords,
    coords: state.coords,
    color: state.colorpicker.color,
    isOpenSidebar: state.marks.isOpenSidebar,
    map: state.map.map,
    temp_id: state.newCoords.temp_id,
    submissionId: state.coords.submissionId,

  }
}

const mapDispatchToProps = {
  addCoordAction,
  removeAllErrors,
  showMarkAction,
  openSidebarAction,
  getCommentsAction,
  removeCoordinatesAction,
  instrumentsAction,
  addMarkAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(Canvas)
